import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { map, startWith, Subscription } from 'rxjs';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'errorChanges',
  standalone: true,
  pure: false,
})
export class ErrorChangesPipe implements PipeTransform, OnDestroy {
  private subscription: Subscription | null = null;
  private errors: ValidationErrors | null = null;
  private subscribedControl: AbstractControl | null = null;

  transform(control: AbstractControl): ValidationErrors | null {
    if (this.subscribedControl !== control) {
      if (this.subscription) this.subscription.unsubscribe();
      this.subscription = control.statusChanges
        .pipe(
          startWith(control.status),
          map(() => control.errors),
        )
        .subscribe((errors) => (this.errors = errors));
      this.subscribedControl = control;
    }

    return this.errors;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
